import uploadcare from 'uploadcare-widget';

import * as Vue from "vue";

// 30 minutes
let pingInterval = 1000 * 60 * 30;

// keeps the session alive
let pingBackend = _.throttle(() => {
    // axios.post('/api/s/ping');
    axios.get('/ping');
}, pingInterval, {leading: true});

export default {
    props: {
        value: {
            default: null
        },
        multiple: {
            type: Boolean,
            default: false
        },
        crop: {
            type: String,
            default: null
        },
        imagesOnly: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        format: {
            type: String,
            default: 'uuid' //url, uuid, object
        },
        doNotStore: {
            type: Boolean,
            default: false,
        },
        preview: {
            type: Boolean,
            default: false,
        },
        inputAcceptTypes: {
            type: String,
            default: '*'
        }
    },
    data() {
        return {
            currentValue: null,
            cacheInfo: {},
        };
    },
    mounted() {
        // this will keep the session alive in case of long uploads
        this.pingInterval = setInterval(pingBackend, pingInterval);
    },
    beforeDestroy() {
        clearInterval(this.pingInterval);
        pingBackend.cancel();
    },
    watch: {
        value(val, oldVal){
            switch (this.format) {
                case 'uuid':
                case 'url':
                    if (this.multiple) {
                        var v1 = JSON.stringify(_.orderBy(val)),
                            v2 = JSON.stringify(_.orderBy(oldVal)),
                            v3 = JSON.stringify(_.orderBy(this.currentValue));
                    } else {
                        var v1 = val, v2 = oldVal, v3 = this.currentValue;
                    }
                    break;
                case 'object':
                    if (this.multiple) {
                        var v1 = JSON.stringify(_.orderBy(_.map(val, item => item.uuid))),
                            v2 = JSON.stringify(_.orderBy(_.map(oldVal, item => item.uuid))),
                            v3 = JSON.stringify(_.orderBy(_.map(this.currentValue, item => item.uuid)));
                    } else {
                        var v1 = val.uuid, v2 = (oldVal ? oldVal.uuid : null), v3 = this.currentValue.uuid;
                    }
                    break;
            }

            if (v1 == v2 || v1 === v3) {
                return;
            }
            this.onValueChange(val);
        }
    },

    methods: {
        onFileDone(file) {
            if (file && file.done) {
                file.done((info) => {
                    switch (this.format) {
                        case 'uuid':
                            this.currentValue = info.uuid;
                            break;
                        case 'url':
                            this.currentValue = info.cdnUrl;
                            break;
                        case 'object':
                            this.currentValue = info;
                            break;
                    }

                    this.$emit('update:model-value', this.currentValue);
                    this.$emit('done', this.currentValue);
                    if (this.value === null) {
                        this.currentValue = null;
                    }
                }).fail(() => {
                    this.currentValue = null;
                });
            } else if (file && file.files) {
                let files = []
                _.each(file.files(), (file)=>{

                    file.done((info) => {
                        switch (this.format) {
                            case 'uuid':
                                files.push(info.uuid);
                                break;
                            case 'url':
                                files.push(info.cdnUrl);
                                break;
                            case 'object':
                                files.push(info);
                                break;
                        }
                    });
                });
                file.promise().done((b)=>{
                    this.currentValue = _.isArray(this.currentValue) ?
                        this.currentValue = [
                            ...this.currentValue,
                            ...files
                        ] :
                        files;

                    this.$emit('update:model-value', this.currentValue);
                    this.$emit('done', this.currentValue);
                    if (this.value === null) {
                        this.currentValue = null;
                    }
                }).fail(() => {
                    this.currentValue = null;
                });
            } else {
                this.$emit('update:model-value', null);
            }
        },
        openDialog() {
            uploadcare.openDialog(null, {
                multiple: this.multiple,
                doNotStore: this.doNotStore,
                previewStep: this.preview,
                inputAcceptTypes: this.inputAcceptTypes
            }).fail(a => {
                if(a) {
                    _.each(a.files(), file => {
                        if (file.state() == 'pending') {
                            file.cancel();
                        }
                    });
                }
            }).done((result) => {
                this.onFileDone(result)
            });
        },
        getValueToUploadCare() {
            if (this.multiple && this.format == 'object') {
                return _.map(this.currentValue, item => item.uuid);
            }
            return this.currentValue;
        },
        onValueChange(val) {
            this.currentValue = val
        }
    }
};
